import initialState from './initialState'

export function incrementPendingTasks(state) {
  state.pendingTasks = state.pendingTasks + 1
}

export function decrementPendingTasks(state) {
  state.pendingTasks = state.pendingTasks - 1
}

export function toggleMenu(state) {
  state.showMenu = !state.showMenu
}

export function toggleSessionMenu(state, payload) {
  state.showSessionMenu =
    typeof payload === 'boolean' ? payload : !state.showSessionMenu
}

export function addNotification(state, payload) {
  state.notifications.push(payload)
}

export function updateProfileProp(state, { key, value }) {
  state.profile[key] = value
}

export function mutateToggleProject(state, { key, value }) {
  state.projectsToggle[key] = value
}

export function setProfile(state, payload) {
  state.profile = payload
}

export function setTitle(state, payload) {
  state.title = payload
}

export function updateOrder(state, { namespace, sortBy }) {
  state.sort[namespace].sortBy = sortBy
  state.sort[namespace].sortOrder =
    state.sort[namespace].sortOrder === 'ASC' ? 'DESC' : 'ASC'
}

export function userPlansUpdated(state, payload) {
  state.userPlans = payload
}

export function nodesUpdated(state, payload) {
  state.nodes = payload
}

export function nodeStopped(state, nodeId) {
  state.nodes = state.nodes.filter(({ id }) => id !== nodeId)
}

export function clustersUpdated(state, payload) {
  state.clusters = payload
}

export function clusterStopped(state, clusterId) {
  state.clusters = state.clusters.filter(({ id }) => id !== clusterId)
}

export function userPlanUpdated(state, payload) {
  state.userPlans = state.userPlans.map(userPlan =>
    userPlan.id === payload.id ? { ...userPlan, ...payload } : userPlan
  )
}

export function userPlanCreated(state, payload) {
  state.userPlans.push({ ...payload, payments: [] })
}

export function userPlanSubscriptionCreated(state, payload) {
  state.userPlans = state.userPlans.map(userPlan =>
    userPlan.id === payload.userPlan
      ? { ...userPlan, subscription: payload.id }
      : userPlan
  )
  state.nodes = state.nodes.map(node =>
    node.userPlanData && node.userPlanData.id === payload.userPlan
      ? {
          ...node,
          userPlanData: { ...node.userPlanData, subscription: payload.id }
        }
      : node
  )
  state.clusters = state.clusters.map(cluster =>
    cluster.userPlanData && cluster.userPlanData.id === payload.userPlan
      ? {
          ...cluster,
          userPlanData: { ...cluster.userPlanData, subscription: payload.id }
        }
      : cluster
  )
}

export function userPlanSubscriptionRemoved(state, subscriptionId) {
  state.userPlans = state.userPlans.map(userPlan =>
    userPlan.subscription === subscriptionId
      ? { ...userPlan, subscription: null }
      : userPlan
  )
  state.nodes = state.nodes.map(node =>
    node.userPlanData && node.userPlanData.subscription === subscriptionId
      ? {
          ...node,
          userPlanData: { ...node.userPlanData, subscription: null }
        }
      : node
  )
  state.clusters = state.clusters.map(cluster =>
    cluster.userPlanData && cluster.userPlanData.subscription === subscriptionId
      ? {
          ...cluster,
          userPlanData: { ...cluster.userPlanData, subscription: null }
        }
      : cluster
  )
}

export function logoutUser(state) {
  Object.assign(state, initialState())
}
